import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-dropdown-info',
  templateUrl: './dropdown-info.component.html',
  styleUrls: ['./dropdown-info.component.scss'],
})
export class DropdownInfoComponent implements OnInit {
  expanded = false;
  _title: any;
  _paragraphs: any;

  @Output() onClick = new EventEmitter<void>();
  @Output() onLinkClick = new EventEmitter<{ type: 'email' | 'info', value: string }>();

  @Input()
  get title() {
    return this._title;
  }
  set title(title: any) {
    this._title = title;
  }

  @Input()
  get paragraphs() {
    return this._paragraphs;
  }
  set paragraphs(paragraphs: any) {
    this._paragraphs = paragraphs;
  }
  constructor() {}

  ngOnInit(): void {}

  reset(): void {
    this.expanded = false;
  }

  toggle(): void {
    this.expanded = !this.expanded;
    this.onClick.emit();
  }

  expandedStyles() {
    return { transform: 'rotate(45deg)', color: '#ec407a' };
  }

  onHtmlClick(event: MouseEvent): void {
    const path = event.composedPath() as HTMLElement[];
    const anchor = path.find(el => el instanceof HTMLAnchorElement) as HTMLAnchorElement | undefined;

    if (!anchor) {
      return;
    }

    event.stopPropagation();

    if (anchor.href.startsWith('mailto:')) {
      const email = anchor.href.replace('mailto:', '');
      this.onLinkClick.emit({ type: 'email', value: email });
      window.location.href = anchor.href;
    } else if (anchor.href.startsWith('http')) {
      this.onLinkClick.emit({ type: 'info', value: anchor.href });
      window.open(anchor.href, '_blank');
    }
  }


}
